import { Row, Form, DatePicker, } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import ButtonLink from 'components/theme_components/ButtonLink';
import {
  getParRateFormulaListbyCriteria,
  GetParRateFormulaListbyCriteriaParams,
  ParRateValueResponse,
  updateParRateStatus,
} from 'services/parametersService';
import Notifications from 'components/theme_components/Notifications';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'components/Auth/Auth';
import { useQuery } from 'react-query';

export type ParRateStatusModalProps = {
  setVisible: (visible: boolean) => void;
  setAddRateValue?: (addRateValue: boolean) => void;
  data: ParRateValueResponse | any;
};

const ParRateStatusModal = ({
  setVisible,
  setAddRateValue,
  data,
}: ParRateStatusModalProps) => {
  const [form] = useForm();
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleSussp, setModalVisibleSussp] = useState(false);

  const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);
  console.log({ typeof: data });
  const id = undefined;
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ratecode: data.ratecode,
        enddate: data.enddate,
      });
    }
  }, []);
  const initialSearchParams: GetParRateFormulaListbyCriteriaParams = {
    formulacode: '',
    formulalabel: '',
    formulastatus: '',
    formulatype: '',
    ratecode: data.ratecode,
    ratelabel: '',
  };
  const { data: RateInFormula, isFetching, refetch } = useQuery(
    [' getParRateFormulaListbyCriteria,', initialSearchParams],
    () =>
      getParRateFormulaListbyCriteria(initialSearchParams).then(
        (res) => res.code
      ),
  );
  const submit = (values: any) => {
    const request: any = {
      enddate: form.getFieldValue('enddate'),

    };
    if (RateInFormula === "200") {
      setModalVisibleSussp(true)

    } else {
      updateParRateStatus({
        ratecode: data.ratecode,
        ratestatus: 'TERM',
      }).then((res) => {
        Notifications({
          status: "success",
          message: 'Le taux a été suspendu avec succès',
          description: res.description,
          duration: 3,
          placement: 'top',
        });
        setVisible(false)
      });
    }

  };

  return (
    <Form form={form} className="no-border-radius ut-wizard-form">
      <Row gutter={16} justify="space-between">
        <FormInput
          col
          xs={24}
          lg={24}
          name="enddate"
          className="form-item no-border-radius"
          layout="vertical"
          extra="JJ/MM/AAAA"
          rules={[{ required: true }]}
        >
          <DatePicker
            className="form-item no-border-radius"
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
          />
        </FormInput>
      </Row>
      <Row justify={'end'}>
        <ButtonLink
          comcode="close"
          className="ut-btn-bordred"
          onClick={() => {
            setVisible(false);
          }}
        />

        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn ml-6"
          // onClick={() => {
          //   setModalVisibleSussp(true);
          // }}
          onClick={(values: any) => {
            submit(values);
          }}
          iconPosition="end"
        />
      </Row>

      <ConfirmModal
        visible={modalVisible}
        status="error"
        message="Le taux existe déjà"
        description="Voulez-vous le mettre à jour ?"
        onConfirm={() => {
          setModalVisible(false);
          setModalVisibleSussp(false);

        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
      <ConfirmModal
        visible={modalVisibleSussp}
        status="error"
        message="Le taux est utilisé dans une formule"
        description="La suspension est impossible"
        onConfirm={() => {
          setModalVisible(false);
          setModalVisibleSussp(false);
          setVisible(false)
        }}
        onCancel={() => !isInspect && setModalVisibleSussp(false)}
        className="modalConfirmOrCancel"
      />
    </Form>
  );
};

export default ParRateStatusModal;
